export default "__VITE_ASSET__9a39794e__"